import {
  ProcessMiningClient,
  SchedulerClient,
  TwinManagementClient,
  DashboardBuilderClient,
  MaintenanceClient,
  TwinReportingClient,
  LifecycleClient,
  TwinDataClient,
  AccessRightsClient,
  PortalClient,
  KnowledgeSpaceClient,
} from "@inctec/smx-ui-client";
import { Interceptors } from "../../../shogun/archive/src-dist/eLearning-ui/accounts/core/OpenAPI";
import axios from "@shared/services/axiosProvider";
import type { InternalAxiosRequestConfig } from "axios";

export function initClients({
  requestInterceptors,
  responseInterceptors,
}: {
  requestInterceptors?: {
    onFulfilled: (
      value: InternalAxiosRequestConfig,
    ) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>;
    onRejected?: (error: any) => any;
  }[];
  responseInterceptors?: {
    onFulfilled: (value: any) => any;
    onRejected?: (error: any) => any;
  }[];
}) {
  ProcessMiningClient.setConfig({
    baseURL: "/api/process-mining",
    throwOnError: true,
  });

  SchedulerClient.setConfig({
    baseURL: "/api/scheduler",
    throwOnError: true,
  });

  TwinManagementClient.setConfig({
    baseURL: "/api/",
    throwOnError: true,
  });

  DashboardBuilderClient.setConfig({
    baseURL: "/api/portal",
    throwOnError: true,
  });

  MaintenanceClient.setConfig({
    baseURL: "/api/",
    throwOnError: true,
  });

  LifecycleClient.setConfig({
    baseURL: "/api/lifecyclereporting",
    throwOnError: true,
  });

  TwinDataClient.setConfig({
    baseURL: "/api/twin-data",
    throwOnError: true,
  });

  AccessRightsClient.setConfig({
    baseURL: "/api",
    throwOnError: true,
  });

  PortalClient.setConfig({
    baseURL: "/api/portal",
    throwOnError: true,
  });

  KnowledgeSpaceClient.setConfig({
    baseURL: "/api/knowledge",
    throwOnError: true,
  });

  requestInterceptors?.forEach((interceptor) => {
    axios.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    ProcessMiningClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    DashboardBuilderClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinManagementClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    SchedulerClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    MaintenanceClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    LifecycleClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinDataClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    AccessRightsClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    PortalClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    KnowledgeSpaceClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
  });
  responseInterceptors?.forEach((interceptor) => {
    axios.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    ProcessMiningClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    DashboardBuilderClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinManagementClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    SchedulerClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    MaintenanceClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    LifecycleClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinDataClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    AccessRightsClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    PortalClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    KnowledgeSpaceClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
  });
}
